class InfoPopUp extends HTMLElement{
  constructor(){
    super()
    // popup Information
    this.infoPopup = this.querySelector(".js-shipping-popup");
    this.infoIcons = document.querySelectorAll(".js-shipping-icon");
    this.closeButton = this.querySelector(".js-shipping-popup-close");
    this.popupBackground = this.querySelector(".js-shipping-bg");
    this.initPopup(this.infoPopup, this.infoIcons, this.closeButton, this.popupBackground);
  }

  connectedCallback() {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if(event) {
        setTimeout(()=> {
          const popup = this.querySelector(".js-shipping-popup");
          const open = document.querySelectorAll(".js-shipping-icon");
          const close = this.querySelector(".js-shipping-popup-close");
          const overlay = this.querySelector(".js-shipping-bg");
          this.initPopup(popup, open, close, overlay);
        })    
      }
    })
  }

  initPopup(popup, open, close, bg) {    
    // open/close popup
    bg.addEventListener("click", () => {
      bg.classList.remove("active");
      popup.classList.remove("active")
    })

    close.addEventListener("click", () => {
      bg.classList.remove("active");
      popup.classList.remove("active")
    })
    
    if (open.length > 0) {
      open.forEach((icon)=> {
        icon.addEventListener("click", () => {        
          bg.classList.add("active");
          popup.classList.add("active");
        })
      })
    }

  }
}
customElements.define('info-popup', InfoPopUp);